/* eslint-disable import/prefer-default-export */
import { Radio } from "@mui/material";
import { useLocation } from "react-router-dom";
import Delete from "../../../assets/delete.svg";

export function AddressList(props) {
  const location = useLocation();
  if (location?.pathname === "/address/add-address") return null;
  const {
    addresses,
    selectedAddressId,
    onSelect,
    selectAddress,
    delAddress,
    states
  } = props;

  return (
    <>
      {addresses.length > 0 && (
        <div className="new-address-heading">
          <h2>Saved Address</h2>
        </div>
      )}
      {addresses?.map((address) => (
        <div
          className={`address-detail pointer hoverlist ${
            selectedAddressId === address.id ? "active" : ""
          }`}
          onClick={() => onSelect(address?.id)}
          key={address.id}
        >
          <div className="address-content">
            <div className="address-content-child">
              <div className="address-detail-heading">
                <div className="address-detail-left">
                  <Radio
                    className="address-detail-left-radio"
                    value={address.id}
                    checked={selectedAddressId === address.id}
                    onChange={selectAddress}
                  />
                </div>
              </div>
              <div className="shipping-address">
                <div className="shipping-full-address">
                  {address?.label && (
                    <div
                      id="selected-addressl"
                      className="address-detail-left"
                      onChange={selectAddress}
                    >
                      <label htmlFor="selected-addressl">{address.label}</label>
                    </div>
                  )}
                  <h2 key={address.id}>
                    {address.address1},{" "}
                    {address?.address2 ? address?.address2 : ""} {address.city},{" "}
                    {
                      states.find(
                        (state) => state.value === address.provinceCode
                      )?.label
                    }
                    , {address.zip}, {address.country}
                    {!!address?.gstNumber && (
                      <strong> GST No. {address.gstNumber}</strong>
                    )}
                  </h2>
                </div>
                <div className="address-detail-right">
                  {selectedAddressId !== address.id && (
                    <button
                      aria-label="delete_address"
                      type="button"
                      className="address-delete-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        delAddress(address.id);
                      }}
                    >
                      <img src={Delete} alt="" />
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="edit-select">
              {selectedAddressId !== address.id && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    delAddress(address.id);
                  }}
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
